import actions from "./actions";

const initState = {
  inventoryData: [],
  inventoryDataLoading: false,
  inventoryDataError: null,

  addSimPinInventoryLoading: false,
  addSimPinInventoryError: null,
  addSimPinInventoryMessage: null,

  getSimPinInventoryResult: [],
  getSimPinInventoryLoading: false,
  getSimPinInventoryError: null,

  inventoryViewDetails: [],
  inventoryViewDetailsLoading: false,
  inventoryViewError: null,
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case actions.GET_SIM_PIN_INVENTORY_DETAILS:
      return {
        ...state,
        inventoryDataLoading: true,
        inventoryDataError: null,
      };

    case actions.GET_SIM_PIN_INVENTORY_DETAILS_SUCCESS:
      return {
        ...state,
        inventoryDataLoading: false,
        inventoryData: action.result,
        inventoryDataError: null,
      };

    case actions.GET_SIM_PIN_INVENTORY_DETAILS_FAILED:
      return {
        ...state,
        inventoryDataLoading: false,
        inventoryDataError: action.error,
      };

    case actions.ADD_SIM_PIN_INVENTORY:
      return {
        ...state,
        addSimPinInventoryLoading: true,
        addSimPinInventoryError: null,
        addSimPinInventoryMessage: null,
      };

    case actions.ADD_SIM_PIN_INVENTORY_SUCCESS:
      return {
        ...state,
        addSimPinInventoryLoading: false,
        addSimPinInventoryError: null,
        addSimPinInventoryMessage: action.payload.message,
      };

    case actions.ADD_SIM_PIN_INVENTORY_FAILED:
      return {
        ...state,
        addSimPinInventoryLoading: false,
        addSimPinInventoryError: action.payload.error,
      };

    case actions.RESET_SIM_PIN_INVENTORY_MESSAGE:
      return {
        ...state,
        addSimPinInventoryMessage: null,
        addSimPinInventoryError: null,
      };

    case actions.GET_SIM_PIN_INVENTORY_LIST:
      return {
        ...state,
        getSimPinInventoryLoading: true,
        getSimPinInventoryError: null,
        getSimPinInventoryResult: [],
      };
    case actions.GET_SIM_PIN_INVENTORY_LIST_SUCCESS:
      return {
        ...state,
        getSimPinInventoryLoading: false,
        getSimPinInventoryResult: action.result,
        getSimPinInventoryError: null,
      };
    case actions.GET_SIM_PIN_INVENTORY_LIST_FAILED:
      return {
        ...state,
        getSimPinInventoryLoading: false,
        getSimPinInventoryError: action.error,
      };

    case actions.GET_SIM_PIN_INVENTORY_VIEW_DETAILS:
      return {
        ...state,
        inventoryViewDetailsLoading: true,
        inventoryViewDetails: [],
        inventoryViewError: false,
      };
    case actions.GET_SIM_PIN_INVENTORY_VIEW_DETAILS_SUCCESS:
      return {
        ...state,
        inventoryViewDetailsLoading: false,
        inventoryViewDetails: action.result,
        inventoryViewError: false,
      };
    case actions.GET_SIM_PIN_INVENTORY_VIEW_DETAILS_FAILED:
      return {
        ...state,
        inventoryViewDetails: [],
        inventoryViewDetailsLoading: false,
        inventoryViewError: action.error,
      };

    default:
      return state;
  }
};

export default reducer;
